import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AdvancedSearchService } from 'src/search/services/advanced-search/advanced-search.service';
import { takeUntil } from 'rxjs/operators';
import { VehicleInfo } from 'src/app/enums/vehicleInfo.enum';
import { MakeOptionState } from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-advanced-search-make',
    templateUrl: './advanced-search-make.component.html',
    styleUrls: ['./advanced-search-make.component.scss'],
    imports: [TranslocoDirective, CommonModule]
})
export class AdvancedSearchMakeComponent implements OnInit, OnDestroy {
  @Output() closePop = new EventEmitter<string>();
  @Input() localSelecedMake: Array<string>;

  makeOptions$: Observable<MakeOptionState> = this.advancedSearchService.makeOptions;

  filteredMakeOPtions: Array<string> = [];
  selectedMakeOptionsValues: Array<string> = [];

  searchMake: string;

  private destroyed$ = new Subject();

  constructor(private advancedSearchService: AdvancedSearchService) {}

  ngOnInit() {
    this.makeOptions$.pipe(takeUntil(this.destroyed$)).subscribe(makeOptionState => {
      this.filteredMakeOPtions = makeOptionState.filteredMakeOptions;
      this.selectedMakeOptionsValues = makeOptionState.selectedMakeOptions;
    });
  }

  selectOption(makeValue: string) {
    const index = this.selectedMakeOptionsValues.findIndex(makeName => makeName === makeValue);
    index === -1 ? this.addMakeOption(makeValue) : this.removeMakeOption(makeValue, index);
  }

  private addMakeOption(makeValue: string) {
    this.selectedMakeOptionsValues.push(makeValue);

    this.updateState();
  }

  private removeMakeOption(makeValue: string, index: number) {
    this.selectedMakeOptionsValues.splice(index, 1);
    this.updateState();
  }

  private updateModelState() {
    const state = this.advancedSearchService._makeOptions.getValue();
    const selectedMakeOptions = this.selectedMakeOptionsValues;

    this.advancedSearchService._makeOptions.next({
      ...state,
      selectedMakeOptions
    });

    this.advancedSearchService.updateFilterOptions(VehicleInfo.VEHICLE_MAKE);
  }

  private updateState() {
    this.updateModelState();
  }

  checked(makeOption: string) {
    return this.selectedMakeOptionsValues.includes(makeOption);
  }

  close() {
    this.closePop.emit();
  }

  onInput(e) {
    this.searchMake = e.target.value.replace(/[^ -~]+/g, '').toLowerCase();

    if (this.searchMake) {
      this.makeOptions$.pipe(takeUntil(this.destroyed$)).subscribe(makeOptionState => {
        this.filteredMakeOPtions = makeOptionState.filteredMakeOptions.filter(option =>
          option.toLowerCase().includes(this.searchMake)
        );
      });
    } else {
      this.makeOptions$
        .pipe(takeUntil(this.destroyed$))
        .subscribe(makeOptionState => (this.filteredMakeOPtions = makeOptionState.filteredMakeOptions));
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
